import script from "./AiChatWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatWidget.vue?vue&type=script&setup=true&lang=js"

import "./AiChatWidget.vue?vue&type=style&index=0&id=9d5d2022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d5d2022"]])

export default __exports__